import React from "react";
import { verifyCards } from "../mock";
import { WavyRule } from "./Guilloche";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifySection() {
  const { valid, refused } = verifyCards;
  return (
    <section id="verify" className="container-x py-16 md:py-20">
      <h2 className="font-number font-semibold" style={{ fontSize: "clamp(1.6rem,3.4vw,2.3rem)" }}>Check it yourself</h2>
      <WavyRule className="my-6 max-w-3xl" />
      <p className="text-[15px] max-w-2xl" style={{ color:"var(--muted)" }}>
        A certificate counts only if it names a real burn that has not already been claimed, and is delivered to the address that burner chose. Anyone can rebuild the whole set from public data on both chains and get the same answer we do.
      </p>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        {/* valid */}
        <div className="rounded-sm p-6" style={{ background:"var(--card)", border:"1px solid rgba(87,191,142,0.35)" }}>
          <div className="flex items-center gap-2 label" style={{ color:"var(--green)" }}>
            <CheckCircle2 size={15}/> {valid.status}
          </div>
          <h3 className="mt-3 font-number font-semibold text-[17px]">A certificate on Zcash mainnet</h3>
          <p className="mt-2 text-[13.5px] leading-relaxed" style={{ color:"var(--muted)" }}>{valid.text}</p>
          <div className="mt-5 space-y-3">
            <Field label="Inscription" value={valid.inscription} />
            <Field label="Burn (BSC)" value={valid.burn} />
          </div>
        </div>

        {/* refused */}
        <div className="rounded-sm p-6" style={{ background:"var(--card)", border:"1px solid rgba(224,67,94,0.35)" }}>
          <div className="flex items-center gap-2 label" style={{ color:"var(--red)" }}>
            <XCircle size={15}/> {refused.status}
          </div>
          <h3 className="mt-3 font-number font-semibold text-[17px]">A forgery the chain accepted</h3>
          <p className="mt-2 text-[13.5px] leading-relaxed" style={{ color:"var(--muted)" }}>{refused.text}</p>
          <div className="mt-5">
            <Field label="Inscription" value={refused.inscription} />
          </div>
        </div>
      </div>
    </section>
  );
}

function Field({ label, value }) {
  return (
    <div className="rounded-sm px-3 py-2.5" style={{ background:"var(--bg-2)", border:"1px solid var(--border)" }}>
      <div className="label mb-1">{label}</div>
      <div className="font-mono text-[11.5px] break-all" style={{ color:"var(--text)" }}>{value}</div>
    </div>
  );
}
